<template>
  <div>
     <router-view></router-view>
  </div>
</template>

<script>
import { isAuthenticated } from '@/services/authService';
import { disconnectSocket } from '@/services/socket';
import { initUnreadMessagesTracking, resetUnreadMessages, totalUnreadMessages } from '@/services/unreadMessages';
import { initPresenceTracking } from '@/services/presence';

export default {
  name: 'App',
  data() {
    return {
      baseTitle: document.title,
    };
  },
  computed: {
    unreadMessagesCount() {
      return totalUnreadMessages();
    },
  },
  watch: {
    '$route'() {
      this.syncMessagingTracking();
    },
    unreadMessagesCount(count) {
      document.title = count > 0 ? `(${count}) ${this.baseTitle}` : this.baseTitle;
    },
  },
  mounted() {
    this.syncMessagingTracking();
  },
  methods: {
    syncMessagingTracking() {
      if (isAuthenticated()) {
        initUnreadMessagesTracking();
        initPresenceTracking();
      } else {
        resetUnreadMessages();
        disconnectSocket();
      }
    },
  },
}
</script>

<style>

</style>
